var t = require('js/lib/translate').t;
var moment = require('moment');
var util = require('js/lib/util');


settingsCtrl.$inject = ['$scope', '$rootScope', '$controller', 'load'];

function settingsCtrl($scope, $rootScope, $controller, load) {

  $controller('commonCtrl', { $scope: $scope });

  $scope.dataLoaded = function() {
    return $scope.settings && true;
  };

  if ($rootScope.auth) {
    load.settings();
  }

  $scope.timePattern = /^([01][0-9]|2[0-3]):?[0-5][0-9]$/;
  $scope.durationPattern = /^\d+$/;


  $scope.createSystemWarning = function(downtime) {
    downtime.problemsTimestamp = downtime.generalEnabled ? new Date() : null;

    if (downtime.downtimeEnabled) {
      var dateTimeStr =  downtime.date + 'T' + moment(downtime.time, "HH:mm").format('HH:mm:ss.SSSZ');
      downtime.serverDownTimestamp = moment.utc(dateTimeStr);
    } else {
      downtime.serverDownTimestamp = null;
      downtime.estimatedDownTimeMinutes = null;
    }
    load.saveDowntime(downtime.getCleanModel());
  };
}

module.exports = settingsCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controllers/settingsCtrl.js
 ** module id = 133
 ** module chunks = 1
 **/